import React, { forwardRef } from 'react';
import { Button, ButtonProps, Theme, useMediaQuery } from '@mui/material';

export interface SecondaryNavigationCtaProps extends ButtonProps {}

/**
 * SecondaryNavigationCtaProps is a proxy component to <Button /> with responsive size
 */
export const SecondaryNavigationCta: React.FC<SecondaryNavigationCtaProps> = forwardRef((props, ref) => {
  const downLg = useMediaQuery<Theme>((theme) => theme.breakpoints.down('lg'));

  return (
    <Button
      ref={ref}
      color={!props.variant || props.variant === 'contained' ? 'primary' : 'secondary'}
      size={downLg ? 'small' : 'medium'}
      {...props}
    />
  );
});
